import { render, staticRenderFns } from "./SelectPCByGroup.vue?vue&type=template&id=64572946"
import script from "./SelectPCByGroup.vue?vue&type=script&lang=js"
export * from "./SelectPCByGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports